import { Record } from 'immutable';
import { HARD_DELETION_REMOVAL } from '../constants/overlayTypes';
const HardDeletionRemovalOverlay = Record({
  audit: null,
  type: HARD_DELETION_REMOVAL
}, 'HardDeletionRemovalOverlay');
export default HardDeletionRemovalOverlay;